import type { FunctionViewModel } from '@trinnvis/dabih-api-client';
import { translateTemplateName } from 'src/i18n/template-content';
import type { OrganizationState } from '../../types';
import { employeeNamesAsText } from '../employees/employee-names-as-text';

export function toFunctionViewModel(
  item: FunctionViewModel,
  o: OrganizationState,
): FunctionViewModel & { assignedEmployeeNames: string } {
  return Object.assign({}, item, {
    name: translateTemplateName(item.name),
    assignedEmployeeNames: item.type === 'COMMON' ? '' : employeeNamesAsText(item, o),
  });
}
